import React from 'react'
import { Link } from "react-router-dom";
import { projects } from '../data/projects';
import "./Projects.css";

const Projects = () => {
  return (
    <div className="container">
      <div className="backhome__link">
        <Link to="/">Back To Home</Link>
      </div>
      {projects?.map((training) => (
        <div className="projects__box">
          <div className="projects__img">
            <a href={training?.link} target="_blank">
              <img src={training.img} alt="" />
            </a>
          </div>
          <div className="projects__title">
            <h4>{training?.title}</h4>
            <p>{training?.description}</p>
          </div>
        </div>
      ))}
    </div>
  )
}

export default Projects